import { render } from "./ApiDocs.vue?vue&type=template&id=63b89916&scoped=true"
import script from "./ApiDocs.vue?vue&type=script&lang=js"
export * from "./ApiDocs.vue?vue&type=script&lang=js"

import "./ApiDocs.vue?vue&type=style&index=0&id=63b89916&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-63b89916"]])

export default __exports__